<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-chart heroicon heroicons-lg"
  >
    <path
      class="heroicon-chart-stand heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M51 2v2h-2V2h2zm18.6 64H22v-2h56v2h-8.4zm-1.57 2l7.5 30h-2.06l-7.5-30h2.06zM49 68h2v20h-2V68zm-17.03 0h2.06l-7.5 30h-2.06l7.5-30z"
    ></path>
    <polygon
      class="heroicon-chart-poster heroicon-component-fill"
      fill="#FFFFFF"
      points="79 65 99 65 99 5 1 5 1 65 21 65 21 63 79 63"
    ></polygon>
    <polygon
      class="heroicon-chart-stripe heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="2 11 98 11 98 12 2 12"
    ></polygon>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M36.1 68l-1.26 5h-6.18l1.25-5h6.18zm34 0l1.24 5h-6.18l-1.25-5h6.18zM53 68v8h-6v-8h6z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M47 4V0h6v4h47v62H80v2h-9.9l7.5 30 .5 2H71.9l-8-32H53v22h-6V68H36.1l-8 32H21.9l.5-2 7.5-30H20v-2H0V4h47zm4-2h-2v2h2V2zm18.6 64H78v-2H22v2h47.59zm-1.57 2h-2.06l7.5 30h2.06l-7.5-30zM49 68v20h2V68h-2zm-17.03 0l-7.5 30h2.06l7.5-30h-2.06zM2 6v4h96V6H2zm0 5v1h96v-1H2zm96 53V13H2v51h18v-2h60v2h18zM37 45.47l-9.32 5.59-9.84-1.97L9.38 58H93v1H7V21h1v35.55l9.16-9.64 10.16 2.03 9.95-5.97 9.89 1 10.22-9.2 10.16 6.09 9.3-4.65L86.9 23.15l4.8-1.6a1 1 0 0 1 .63 1.9l-4.21 1.4-9.96 12.94-.15.08V41h-1v-2.63l-9.54 4.77L58 37.47V41h-1v-3.2l-9 8.1V49h-1v-3.05l-9-.9V49h-1v-3.53zM88 29v4h-1v-4h1zm-1 8h1v4h-1v-4zm0 8h1v4h-1v-4zm0 8h1v4h-1v-4zm-29-8v4h-1v-4h1zm0 8v4h-1v-4h1zm-21 0h1v4h-1v-4zm-19 0v4h-1v-4h1zm9 0h1v4h-1v-4zm20 0h1v4h-1v-4zm21-8v4h-1v-4h1zm-1 8h1v4h-1v-4zm11-8v4h-1v-4h1zm0 8v4h-1v-4h1zM66 17v2H34v-2h32z"
    ></path>
  </svg>
</template>
